import { types, actions, Action } from '.';
import { SagaIterator } from 'redux-saga';
import { put, takeLatest, call } from 'redux-saga/effects';
import { actions as appUIActions } from '../../uis/app';
import { PaidPaymentResponse, PaymentProduct } from 'src/models/payment';
import * as paymentApi from '../../../api/payment';
import { rollbar } from 'src';
import { ErrorMessageType } from 'src/utils/constValues';

export default function* watchPaymentData(): SagaIterator {
    yield takeLatest(types.SUBMIT_PAID_PRODUCTS_ASYNC, submitPaidProductsAsync);
    yield takeLatest(types.GET_PAYMENT_PRODUCTS_ASYNC, getPaymentProductsAsync);
}

export function* submitPaidProductsAsync(action: Action): SagaIterator {
    try {
        yield put(actions.actionServerDataPaymentRequested());

        const response: PaidPaymentResponse = yield call(paymentApi.submitPaidProducts, action.paidProducts);

        if (response.success) {
            yield put(actions.submitPaidProductsSucceeded());
            yield put(appUIActions.setMessageIndicator('Submit paid products successfully', 'success'));
        } else {
            yield put(actions.actionServerDataPaymentFailed(response.message, response.messageType));
            yield put(appUIActions.setMessageIndicator(response.message, 'error'));
            yield call(console.log, 'Submit paid products failed!');
        }
    } catch (e) {
        console.log(e);
        yield put(actions.actionServerDataPaymentFailed('Submit paid products failed!', ErrorMessageType.ERROR_FROM_INTERNAL_SYSTEM));
        yield put(appUIActions.setMessageIndicator('Submit paid products failed!', 'error'));
        yield call(console.log, 'Cannot submit paid products answers!');
        rollbar.error('Cannot submit paid products answers!');
    }
}

export function* getPaymentProductsAsync(): SagaIterator {
    try {
        yield put(actions.getPaymentProductsLoading());

        const products: Array<PaymentProduct> = yield call(paymentApi.getPaymentProducts);

        if (products != undefined) {
            yield put(actions.getPaymentProductsSucceeded(products));
        } else {
            yield call(console.log, 'Cannot get products!');
        }
        yield put(actions.getPaymentProductsFailed());
    } catch (e) {
        yield call(console.log, 'Cannot get products!');
        yield put(actions.getPaymentProductsFailed());
        rollbar.error('Cannot get products!');
    }
}


// WEBPACK FOOTER //
// ./src/modules/entities/payment/saga.ts